import React, { createContext, useState, useContext } from 'react'

const InsuranceContext = createContext()

export const InsuranceProvider = ({ children }) => {
  const [patients, setPatients] = useState([])
  const [currentPatient, setCurrentPatient] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  const searchPatients = async (query) => {
    setIsLoading(true)
    setError(null)
    try {
      // TODO: Call search API
      console.log('Searching patients:', query)
    } catch (err) {
      setError(err.message)
    } finally {
      setIsLoading(false)
    }
  }

  const getPatient = async (patientId) => {
    setIsLoading(true)
    setError(null)
    try {
      // TODO: Call get patient API
      console.log('Getting patient:', patientId)
    } catch (err) {
      setError(err.message)
    } finally {
      setIsLoading(false)
    }
  }

  const updatePatient = async (patientId, data) => {
    setIsLoading(true)
    setError(null)
    try {
      // TODO: Call update patient API
      console.log('Updating patient:', patientId, data)
    } catch (err) {
      setError(err.message)
    } finally {
      setIsLoading(false)
    }
  }

  const value = {
    patients,
    currentPatient,
    isLoading,
    error,
    searchPatients,
    getPatient,
    updatePatient
  }

  return (
    <InsuranceContext.Provider value={value}>
      {children}
    </InsuranceContext.Provider>
  )
}

export const useInsurance = () => {
  const context = useContext(InsuranceContext)
  if (!context) {
    throw new Error('useInsurance must be used within InsuranceProvider')
  }
  return context
}
